/**
 * The default pending body for a customer screen: a live status line, then skeleton bones in the
 * layout of what will arrive. Screens should use this instead of going blank while they wait.
 */
import * as stylex from "@stylexjs/stylex";
import "@lattice/tokens/space.stylex";
import { space } from "@lattice/tokens/space.stylex";
import type { Bone } from "./Skeleton.tsx";
import { Skeleton } from "./Skeleton.tsx";
import { Status } from "./Status.tsx";
export function Pending({
  message,
  bones = ["title", "line", "control"]
}: {
  readonly message: string;
  readonly bones?: readonly Bone[];
}) {
  return <div className="x78zum5 xdt5ytf x1r0x45p xh8yej3" data-testid="pending">
      <Status>{message}</Status>
      {bones.map((bone, index) => <Skeleton key={`${bone}-${String(index)}`} bone={bone} />)}
    </div>;
}